import styled from "styled-components";

export const Dot = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid white;
  margin: 0 3px;
  display: inline-block;
  background-color: var(--color-azul-mrpay);
  transform: scale(0.2);
  align-items: center;
  justify-content: center;
  animation: loader-animation 1.2s infinite;

  &:nth-child(2) {
    animation-delay: 0.2s;
    background-color: var(--color-dourado-mrpay);
  }

  &:nth-child(3) {
    animation-delay: 0.4s;
  }

  @keyframes loader-animation {
    0%,
    100% {
      transform: scale(0.2);
    }

    50% {
      transform: scale(1);
    }
  }
`;

export const Load = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid white;
  margin: 0 3px;
  display: contents;
  background-color: var(--color-azul-mrpay);
  transform: scale(0.2);
  align-items: center;
  justify-content: center;
  animation: loader-animation 1.2s infinite;

  @keyframes loader-animation {
    0%,
    100% {
      transform: scale(0.2);
    }

    50% {
      transform: scale(1);
    }
  }
`;
